import { useMemo } from 'react';

import { useDebounce } from '../../../utils/hooks/useDebounce';
import { PASSWORD_CONSTANTS } from '../constants/password';
import { validatePassword } from '../utils/passwordValidation';

export const usePasswordValidation = (
  password: string
): {
  passwordStrength: ReturnType<typeof validatePassword>;
  showPasswordStrength: boolean;
  isValid: boolean;
} => {
  const debouncedPassword = useDebounce(password, PASSWORD_CONSTANTS.VALIDATION_DEBOUNCE);

  const passwordStrength = useMemo(() => {
    return validatePassword(debouncedPassword);
  }, [debouncedPassword]);

  const showPasswordStrength = Boolean(password && password.length > 0);

  return {
    passwordStrength,
    showPasswordStrength,
    isValid: passwordStrength.isValid
  };
};
